// extracted by mini-css-extract-plugin
export default {"customTextarea":"CustomTextarea_customTextarea__kGgKw"};